<div class="dialog-loading" *ngIf="(loading$ | async)">
  <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
  <div class="dialog-title">{{'modules.crm.leads.managerSchedulerDialog.title' | translate}}</div>
  <div class="dialog-close" (click)="closeDialog(false)">
    <mat-icon>close</mat-icon>
  </div>
</div>

<div class="dialog-content no-overflow">
  <div class="scheduler-header df jc-c ai-s gap20">
    <button class="button-form-field gray df ai-c jc-c" (click)="disablesPrevious ? '' : navCalendar('prev')">
      <mat-icon class="button-form-field-icon">navigate_before</mat-icon>
    </button>
    <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 150px; min-width: 150px">
      <mat-label>{{'modules.crm.leads.managerSchedulerDialog.labels.date' | translate}}</mat-label>
      <input matInput [matDatepicker]="date" [formControl]="dateControl" [min]="minDate" (dateChange)="getManagerSchedule()">
      <mat-datepicker-toggle matSuffix [for]="date">
      </mat-datepicker-toggle>
      <mat-datepicker #date></mat-datepicker>
    </mat-form-field>
    <button class="button-form-field gray df ai-c jc-c" (click)="navCalendar('next')">
      <mat-icon class="button-form-field-icon">navigate_next</mat-icon>
    </button>
  </div>

  <div class="scheduler-content scrollable scroll-content-padding">
    <div class="full-date">{{dateControl.value | date: 'EEEE, dd MMMM yyyy р.'}}</div>
    <div class="empty-block" *ngIf="!(scheduler$ | async)?.length">
      <mat-icon>today</mat-icon>
      <span>{{'modules.crm.leads.managerSchedulerDialog.empty' | translate}}</span>
    </div>
    <div class="df-c" *ngIf="(scheduler$ | async)?.length">
      <div class="scheduler-item df gap20 jc-s ai-c" *ngFor="let hour of (scheduler$ | async)">
        <div class="hour bold">
          <span>{{hour.hour}}</span>
        </div>
        <div class="minutes-grid df grow">
          <div class="minute grow" *ngFor="let minute of hour.tasks"
               [ngStyle]="getColor(minute.taskId!)"
               [ngClass]="{'empty': !minute.busy, 'merged': minute.mergeNextCell}"
               (contextmenu)="gridDoubleClick(hour.hour!, minute, $event)"
               (click)="gridClick(hour.hour!, minute)">
            <div *ngIf="!minute.busy">{{minute.from?.substr(0, 5)}}</div>
            <div *ngIf="minute.busy && !minute.mergePrevCell"
                 matTooltip="{{(minute.contact?.name ? minute.contact?.name + '. ' : '')
                 + (minute.project?.name ? minute.project?.name + '. ' : '')
                 + (minute.taskName ? minute.taskName : '')}}"
            >
              {{minute.contact?.name
              ? minute.contact?.name
              : minute.project?.name
                ? minute.project?.name
                : minute.taskName ? minute.taskName : ''}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #taskTimeInfo>
  <div class="taskTimeInfo-selected-time df-c gap10">
    <div class="bold">{{'modules.crm.leads.managerSchedulerDialog.labels.time' | translate}}</div>
    <div>{{selectedStart ? selectedStart : '--'}} - {{selectedEnd ? selectedEnd : '--'}}</div>
    <div class="df gap20">
      <button class="action-button gray" [disabled]="!selectedStart && !selectedEnd" (click)="clearTimes()">{{'common.buttons.cancel' | translate}}</button>
      <button class="action-button green" [disabled]="!selectedStart || !selectedEnd" (click)="setTaskDateTime()">{{'common.buttons.choose' | translate}}</button>
    </div>
  </div>
</ng-template>
